var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.game)?_c('div',{staticClass:"game-details"},[_c('svgIcons',{staticClass:"hide"}),_c('TopSection',{attrs:{"game":_vm.game}}),_c('PromoBanner',{attrs:{"game":_vm.game}}),_c('InfoSection',{attrs:{"game":_vm.game}})],1):_c('div',{staticClass:"game-details"})
}
var staticRenderFns = []

export { render, staticRenderFns }